import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class FeesService {

    // getfeestype

    static getfeestype(item) {
        const user = JSON.parse(localStorage.getItem("user"));
        const dynamicPaths = getApiPaths(user?.data?.roleId?.name);

        let api = `${API_BASE_URL}${dynamicPaths.getfeeType}`;
        const params = new URLSearchParams();

        params.append("limit", item?.limit || 25);
        params.append("page", item?.page || 1);

        if (item?.id) params.append("id", item.id);
        if (item?.status) params.append("status", item.status);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api);
    }


    static addfeestype(data) {
        const user = JSON.parse(localStorage.getItem("user"));
        const dynamicPaths = getApiPaths(user?.data?.roleId?.name);

        const api = `${API_BASE_URL}${dynamicPaths.addfeeType}`;
        return axiosInstance
            .post(api, data)

    }

    static editfeestype(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editfeeType}`;
        return axiosInstance
            .put(api, data)

    }


    // standard fees

    static getStandardfees(item) {
        const user = JSON.parse(localStorage.getItem("user"));
        const dynamicPaths = getApiPaths(user?.data?.roleId?.name);

        let api = `${API_BASE_URL}${dynamicPaths.getFees}`;
        const params = new URLSearchParams();


        if (item?.id) params.append("id", item.id);
        if (item?.standardId) params.append("standardId", item.standardId);
        if (item?.session) params.append("session", item.session);
        if (item?.status) params.append("status", item.status);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api);
    }


    static addStandardfees(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addStandardfees}`;
        return axiosInstance
            .post(api, data)

    }

    static addFeeCollection(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addFeeCollection}`;
        return axiosInstance
            .post(api, data)

    }


    static getFeesCollection(item) {
        let api = "";
        api = `${API_BASE_URL}${API_PATHS.getFeeCollection}`;
        const params = new URLSearchParams();


        if (item?.id) params.append("id", item.id);
        if (item?.fromDate) params.append("fromDate", item.fromDate);
        if (item?.session) params.append("session", item.session);
        if (item?.toDate) params.append("toDate", item.toDate);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api);
    }

    static getDemandReport(item) {
        let api = "";
        api = `${API_BASE_URL}${API_PATHS.getDemandReport}`;
        const params = new URLSearchParams();


        if (item?.id) params.append("id", item.id);
        if (item?.standardId) params.append("standardId", item.standardId);
        if (item?.session) params.append("session", item.session);
        if (item?.sectionId) params.append("sectionId", item.sectionId);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api);
    }



    static getDiscountReport(item) {
        let api = "";
        api = `${API_BASE_URL}${API_PATHS.getDiscountReport}`;
        const params = new URLSearchParams();


        if (item?.id) params.append("id", item.id);
        if (item?.standardId) params.append("standardId", item.standardId);
        if (item?.session) params.append("session", item.session);
        if (item?.sectionId) params.append("sectionId", item.sectionId);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api);
    }


    static gettransportReport(item) {
        let api = "";
        api = `${API_BASE_URL}${API_PATHS.gettransportReport}`;
        const params = new URLSearchParams();


        if (item?.id) params.append("id", item.id);
        if (item?.standardId) params.append("standardId", item.standardId);
        if (item?.session) params.append("session", item.session);
        if (item?.sectionId) params.append("sectionId", item.sectionId);
        if (item?.fromDate) params.append("fromDate", item.fromDate);
        if (item?.toDate) params.append("toDate", item.toDate);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api);
    }



    static getDueReport(item) {
        let api = "";
        api = `${API_BASE_URL}${API_PATHS.getDueReport}`;
        const params = new URLSearchParams();


        if (item?.id) params.append("id", item.id);
        if (item?.standardId) params.append("standardId", item.standardId);
        if (item?.session) params.append("session", item.session);
        if (item?.sectionId) params.append("sectionId", item.sectionId);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api);
    }


    static addTransportFeeCollection(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addtransportFeeCollection}`;
        return axiosInstance
            .post(api, data)

    }


    static getstudentFeesDetails(item) {
        const user = JSON.parse(localStorage.getItem("user"));
        const dynamicPaths = getApiPaths(user?.data?.roleId?.name);

        let api = `${API_BASE_URL}${dynamicPaths.getstudentFeesDetails}`;
        const params = new URLSearchParams();


        if (item?.id) params.append("id", item.id);
        if (item?.studentId) params.append("studentId", item.studentId);
        if (item?.session) params.append("session", item.session);
        if (item?.status) params.append("status", item.status);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api);
    }




    static editStandardfees(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editStandardfees}`;
        return axiosInstance
            .put(api, data)


    }
    static addRoute(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addRoute}`;
        return axiosInstance
            .post(api, data)

    }

    static editRoute(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editRoute}`;
        return axiosInstance
            .put(api, data)


    }

    static getRoute(item) {

        let api = "";
        api = `${API_BASE_URL}${API_PATHS.getRoute}`;
        const params = new URLSearchParams();


        if (item?.id) params.append("id", item.id);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api);
    }




}

export default FeesService;
